module.exports = __webpack_public_path__ + "assets/img/cjm3.4453aa66.png";